/*Get ROLE */
export const GET_ROLES = "GET_ROLES"
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS"
export const GET_ROLES_FAIL = "GET_ROLES_FAIL"

/*Get ROLE TYPES */
export const GET_ROLE_TYPES = "GET_ROLE_TYPES"
export const GET_ROLE_TYPES_SUCCESS = "GET_ROLE_TYPES_SUCCESS"
export const GET_ROLE_TYPES_FAIL = "GET_ROLE_TYPES_FAIL"
